import { gql } from 'graphql-request'

export namespace DashboardQueries {
  export const QUERY_KEYS = {
    getTicketSection: 'getTicketSection',
    getOtaTicketSection: 'getOtaTicketSection',
    getHomeReadinessSection: 'getHomeReadinessSection',
    getScheduledCommunicationsSection: 'getScheduledCommunicationsSection',
    getSupplySection: 'getSupplySection',
  }

  export function getTicketSection() {
    return gql`
      query getTicketSection($marketSegmentIds: [Int!], $ticketTypes: [String!]) {
        agmDashboard(marketSegmentIds: $marketSegmentIds, ticketTypes: $ticketTypes) {
          totalOpenTickets
          totalNewTickets
          totalNeedsActionTickets
          totalAwaitingResponseTickets
          totalEscalatedTickets
          totalSevenDayGuaranteeTickets
          totalMaintenanceTickets
          totalLexitTickets
        }
      }
    `
  }

  export function getOtaTicketSection() {
    return gql`
      query getOtaTicketSection($marketSegmentIds: [Int!], $ticketTypes: [String!]) {
        agmDashboard(marketSegmentIds: $marketSegmentIds, ticketTypes: $ticketTypes) {
          totalOpenTickets
          totalNewTickets
          totalNeedsActionTickets
          totalAwaitingResponseTickets
          totalEscalatedTickets
          totalSevenDayGuaranteeTickets
          totalMaintenanceTickets
          totalLexitTickets
        }
      }
    `
  }

  export function getHomeReadinessSection() {
    return gql`
      query getHomeReadinessSection($marketSegmentIds: [Int!]) {
        agmDashboard(marketSegmentIds: $marketSegmentIds) {
          totalMoveIns
          totalLexitReservations
          totalUpcomingReservationsPendingApproval
          totalFxReservations
          totalUpcomingMoveOuts
          totalHomesReady
          totalHomesNotReady
          totalPendingInspections
          totalFutureDeinstalls
        }
      }
    `
  }

  export function getScheduledCommunicationsSection() {
    return gql`
      query getScheduledCommunicationsSection($marketSegmentIds: [Int!]) {
        agmDashboard(marketSegmentIds: $marketSegmentIds) {
          totalPendingApprovalScheduledCommunications
          totalPendingApprovalScheduledCommunicationsNextWeek
          totalPendingApprovalScheduledCommunicationsToday
          totalPendingDeliveryScheduledCommunications
          totalPendingDeliveryScheduledCommunicationsNextWeek
          totalPendingDeliveryScheduledCommunicationsToday
        }
      }
    `
  }

  export function getSupplySection() {
    return gql`
      query getSupplySection($marketSegmentIds: [Int!]) {
        agmDashboard(marketSegmentIds: $marketSegmentIds) {
          totalOccupiedStandardHomes
          totalBlockedStandardHomes
          totalVacantStandardHomes
          totalStandardHomes
          standardHomeOccupancy
          totalOccupiedAutopilotHomes
          totalBlockedAutopilotHomes
          totalVacantAutopilotHomes
          totalAutopilotHomes
          autopilotHomeOccupancy
          totalUpcomingAutopilotMoveOuts
        }
      }
    `
  }
}
